import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getEntityStateTypeCombo from '../../services/dossier/get/getEntityStateTypeCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntityStateTypeCombo ({ countryId, resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (countryId !== -1) {
      combo = yield call(getEntityStateTypeCombo, auth.token, countryId)
    }
    if (resolve) {
      resolve(combo)
    } else {
      yield put(fetchCombosSuccess({ entityStateTypeCombo: combo }))
    }
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchEntityStateTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_ENTITY_STATE_COMBO, fetchEntityStateTypeCombo)
}
